export const alcoholAndControlledSubstanceConsentAndRelease = (name?: string, ssn?: string, date?: string) => {
  return [
    { text: 'Alcohol and Controlled Substance Consent and Release', style: 'h1' },

    { text: 'Have you ever refused to be tested for drugs & alcohol at any time in last 2 years?', fontSize: 11, margin: [0, 10, 0, 0] },
    {
      columns: [
        {
          width: 'auto',
          canvas: [
            {
              type: 'rect',
              x: 0,
              y: 0,
              w: 10,
              h: 10,
              lineWidth: 1,
            },
          ],
        },
        {
          text: 'Yes',
          fontSize: 11,
          margin: [5, 0, 20, 0],
        },
        {
          width: 'auto',
          canvas: [
            {
              type: 'rect',
              x: 0,
              y: 0,
              w: 10,
              h: 10,
              lineWidth: 1,
            },
            {
              type: 'line',
              x1: 1,
              y1: 5,
              x2: 4,
              y2: 8,
              lineWidth: 1,
            },
            {
              type: 'line',
              x1: 4,
              y1: 8,
              x2: 9,
              y2: 2,
              lineWidth: 1,
            },
          ],
        },
        {
          text: 'No',
          fontSize: 11,
          margin: [5, 0, 0, 0],
        },
      ],
      margin: [0, 10, 0, 0],
    },

    { text: 'Have you ever tested positive for drugs or alcohol at any time in the last 2 years?', fontSize: 11, margin: [0, 10, 0, 0] },
    {
      columns: [
        {
          width: 'auto',
          canvas: [
            {
              type: 'rect',
              x: 0,
              y: 0,
              w: 10,
              h: 10,
              lineWidth: 1,
            },
          ],
        },
        {
          text: 'Yes',
          fontSize: 11,
          margin: [5, 0, 20, 0],
        },
        {
          width: 'auto',
          canvas: [
            {
              type: 'rect',
              x: 0,
              y: 0,
              w: 10,
              h: 10,
              lineWidth: 1,
            },
            {
              type: 'line',
              x1: 1,
              y1: 5,
              x2: 4,
              y2: 8,
              lineWidth: 1,
            },
            {
              type: 'line',
              x1: 4,
              y1: 8,
              x2: 9,
              y2: 2,
              lineWidth: 1,
            },
          ],
        },
        {
          text: 'No',
          fontSize: 11,
          margin: [5, 0, 0, 0],
        },
      ],
      margin: [0, 10, 0, 0],
    },

    { text: 'Have you ever tested positive on any pre-employment drug or alcohol test for a job which you applied for but did not obtain?', fontSize: 11, margin: [0, 10, 0, 0],  },
    {
      columns: [
        {
          width: 'auto',
          canvas: [
            {
              type: 'rect',
              x: 0,
              y: 0,
              w: 10,
              h: 10,
              lineWidth: 1,
            },
          ],
        },
        {
          text: 'Yes',
          fontSize: 11,
          margin: [5, 0, 20, 0],
        },
        {
          width: 'auto',
          canvas: [
            {
              type: 'rect',
              x: 0,
              y: 0,
              w: 10,
              h: 10,
              lineWidth: 1,
            },
            {
              type: 'line',
              x1: 1,
              y1: 5,
              x2: 4,
              y2: 8,
              lineWidth: 1,
            },
            {
              type: 'line',
              x1: 4,
              y1: 8,
              x2: 9,
              y2: 2,
              lineWidth: 1,
            },
          ],
        },
        {
          text: 'No',
          fontSize: 11,
          margin: [5, 0, 0, 0],
        },
      ],
      margin: [0, 10, 0, 10],
    },

    { text: 'If you answered yes to any of the above questions, attach a statement of explanation and provide proof of the return to duty process.', style: 'p', bold: true },

    { text: 'I understand that, as required by the Federal Motor Carrier Safety Regulations and company policy, all drivers must submit to alcohol and controlled substance testing as a condition of employment. I also understand that any offer of employment will be contingent upon the results of an alcohol and controlled substance test.', style: 'p'},

    { text: 'Therefore, I agree to submit to the following alcohol and controlled substance tests in accordance and as defined by the Federal Motor Carrier Safety Regulation and this company’s policies:', style: 'p' },

    { text: '• Pre-Employment Testing', style: 'p' },
    { text: '- All applicants must undergo a drug test with a verified negative result as a condition of employment.', style: 'p', margin: [20, 0, 0, 10] },

    { text: '• Post-Accident Testing', style: 'p' },
    { text: '- Alcohol and controlled substances tests are required after accidents involving a fatality, or when a driver receives a citation under state or local law for a moving traffic violation arising from the accident.', style: 'p', margin: [20, 0, 0, 10] },

    { text: '• Random Testing', style: 'p' },
    { text: '- Drivers are subject to random alcohol and controlled substances testing as required by DOT and FMCSA regulations.', style: 'p', margin: [20, 0, 0, 10] },

    { text: '• Reasonable Suspicion Testing', style: 'p' },
    { text: '- Drivers are required to submit to an alcohol and/or controlled substances test when a trained supervisor has reasonable suspicion to believe that the driver has violated the prohibitions of this policy.', style: 'p', margin: [20, 0, 0, 10] },

    { text: '• Return-to-Duty and Follow-Up Testing', style: 'p' },
    { text: '- Drivers who have tested positive or violated this policy must undergo return-to-duty testing and follow-up testing as required by a SAP.', style: 'p', margin: [20, 0, 0, 10] },

    { text: 'Consequences for Violations', style: 'p', bold: true, margin: [0, 10, 0, 10] },

    { text: '1. Positive Alcohol or Drug Test', style: 'p' },
    { text: '- Drivers who test positive for alcohol (0.04 or greater) or controlled substances will be immediately removed from safety-sensitive functions.', style: 'p', margin: [20, 0, 0, 10]},
    { text: '- The driver will be referred to a SAP for evaluation and must complete the recommended treatment program before returning to duty.', style: 'p', margin: [20, 0, 0, 10]},
    { text: '- Return-to-duty and follow-up testing will be conducted as required by the SAP.', style: 'p', margin: [20, 0, 0, 10]},

    { text: '2. Positive Alcohol or Drug Test', style: 'p' },
    { text: '- Refusal to submit to required testing will be treated as a positive test result, and the driver will be subject to the same consequences as a positive test result.', style: 'p', margin: [20, 0, 0, 10]},

    { text: 'Confidentiality', style: 'p', bold: true, margin: [0, 10, 0, 10] },
    { text: 'This policy applies to all drivers who operate commercial motor vehicles (CMVs) requiring a commercial driver’s license (CDL) as per DOT and FMCSA regulations.', style: 'p' },

    { text: 'Driver Education and Training', style: 'p', bold: true, margin: [0, 10, 0, 10] },
    { text: 'Drivers will receive training on the effects and consequences of alcohol and drug use on personal health, safety, and the work environment. Supervisors will receive training on recognizing signs and symptoms of alcohol misuse and drug use.', style: 'p' },

    { text: 'I certify that I have read, understand, and agree to abide by the condition of this consent and release form.', style: 'p' },

    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 200,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 500,
          y1: 0,
          x2: 350,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
    },

    { text: "Driver's Signature", style: 'label', margin: [0, -2, 0, 0] },
    { text: `${date}`, margin: [350, -32, 0, 0] },
    { text: "Date", style: 'label', margin: [350, 5, 0, 0] },

    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 20,
          x2: 200,
          y2: 20,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 500,
          y1: 20,
          x2: 350,
          y2: 20,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
    },

    { text: `${name}`, margin: [0, -22, 0, 0] },
    { text: "Print Name", style: 'label', margin: [0, 5, 0, 0] },
    { text: `${ssn}`, margin: [350, -32, 0, 0] },
    { text: "Social Security Number", style: 'label', margin: [350, 5, 0, 0] },

    { text: '', pageBreak: 'before' },
  ];
};